import { AiOutlineWarning } from 'react-icons/ai';
import { ColorPickerField } from '../components/ColorPickerField';
import slate from '../packages/plugins/content/slate';

const defaultSlate = slate();

const warningPlugin: any = {
  Renderer: ({ children, data }: any) => (
    <div
      className="warning-content"
      style={{
        display: 'flex',
        background: data?.backgroundColor
          ? data?.backgroundColor
          : 'rgba(255, 23, 68,1)',
        padding: '9px 11px',
        borderRadius: '50px',
        minWidth: 400,
        maxWidth: '700px',
        alignItems: 'center',
        margin: '10px auto',
      }}
    >
      <div
        className="warning-icon"
        style={{
          fontSize: '48px',
          background: 'white',
          borderRadius: '50px',
          padding: '6px 9px 10px',
          color: 'black',
        }}
      >
        <AiOutlineWarning />
      </div>
      <div
        className="warning-text"
        style={{
          paddingLeft: 10,
          width: '90%',
          color: '#fff',
          paddingRight: 10,
        }}
      >
        {children}
      </div>
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: defaultSlate,
          data: defaultSlate.createData(({ plugins }) => ({
            children: [
              {
                plugin: plugins.headings.h1,
                children: ['WARNING'],
              },
              {
                plugin: plugins.headings.h3,
                children: ['Warning subtitle'],
              },
            ],
          })),
        },
      ],
    ];
  },

  id: 'warning-plugin',
  title: 'Warning Box',
  // description: 'emergency content plugin',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      required: ['backgroundColor'],
      properties: {
        // backgroundColor: { type: 'string' },
        backgroundColor: {
          type: 'string',
          default: 'rgba(255, 23, 68,1)',
          uniforms: {
            component: ColorPickerField,
            label: 'Background Color: ',
          },
        },
      },
    },
  },
};

export default warningPlugin;
